const statuses = {
  live: true,
  approved: true,
  completed: false,
  draft: false,
  denied: false,
  pending: false,
};

export const campaignEndTimeDisplay = (
  status,
  endsTime,
) => endsTime !== null && statuses[status.toLowerCase()];
